import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAuth } from '~/src/hooks'

export const Top = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  console.log('====isAuthenticated top', isAuthenticated)
  useEffect(() => {
    if (!isAuthenticated) {
      return navigate('/admin/login', { replace: true })
    }
    navigate('/admin')
  }, [isAuthenticated])

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
      }}
    >
      <CircularProgress />
    </Box>
  )
}
